// extracted by mini-css-extract-plugin
module.exports = {"AverageRating":"AverageRating_AverageRating__nkIiB","RatingAverage":"AverageRating_RatingAverage__3_rog","RatingCount":"AverageRating_RatingCount__VEV0N"};